import script from "./wipCompletion.vue?vue&type=script&setup=true&lang=ts"
export * from "./wipCompletion.vue?vue&type=script&setup=true&lang=ts"

import "./wipCompletion.vue?vue&type=style&index=0&id=c6a8c62c&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6a8c62c"]])

export default __exports__